module.exports = __webpack_public_path__ + "static/media/iceberg-background.18e89ebf.svg";